module.exports = __webpack_public_path__ + "img/hohlsaum_karminrot_ral3002.9b258bf8.jpg";